module.exports = __webpack_public_path__ + "img/schoolSignage.5e4bf7d0.png";